import { render, staticRenderFns } from "./GetAllAdmin.vue?vue&type=template&id=1b28c88a&"
import script from "./GetAllAdmin.vue?vue&type=script&lang=js&"
export * from "./GetAllAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports